import { render } from "./HotelBookingDashboard.vue?vue&type=template&id=0db0c8a5"
import script from "./HotelBookingDashboard.vue?vue&type=script&lang=js"
export * from "./HotelBookingDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__